import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, inject } from '@angular/core';
import { Netzzuordnung } from '../../domain/model/netzzuordnung';
import { RoutingService } from '../../service/common/routing/routing.service';
import { Sort } from '@angular/material/sort';
import { NetzbetreiberType } from '../../domain/model/netzbetreibertype';

@Component({
    selector: 'tnb-netzzuordnungen-table',
    templateUrl: './netzzuordnungen-table.component.html',
    styleUrls: [
        './netzzuordnungen-table.component.scss',
    ],
    standalone: false,
})
export class NetzzuordnungenTableComponent implements OnChanges {
    routingService = inject(RoutingService);

    public static readonly DEFAULT_COLUMNS = [
        'netzgruppe',
        'ortsname',
        'stationsname',
        'trafoFeldName',
        'uuid',
        'uuidDatum',
        'technischerPlatz',
    ];

    public static readonly WESTNETZ_COLUMNS_PRE = [
        'netzbetreiber.stadtwerkeId',
        'netzbetreiber.name',
        'netzbetreiber.teilgebiet',
    ];

    public static readonly WESTNETZ_COLUMNS_POST = [
        'trafoFeldNummer',
    ];


    @Input()
    public netzzuordnungen: Netzzuordnung[];

    public columnsToDisplay = [];

    @Input()
    public sortDirection: string;

    @Input()
    public sortActive: string;

    @Input()
    public netzbetreiberType: NetzbetreiberType;

    @Output()
    public sortChange = new EventEmitter<Sort>();

    public _sortChange($event: Sort) {
        if ($event.direction === '') {
            $event.active = '';
        }
        this.sortChange.emit($event);
    }

    ngOnChanges(changes: SimpleChanges): void {

        if (changes.netzbetreiberType) {
            this.netzbetreiberType = changes.netzbetreiberType.currentValue;
        }

        this.columnsToDisplay = this.generateColumnsToDisplay(this.netzbetreiberType);
    }

    private generateColumnsToDisplay(netzbetreiberType: NetzbetreiberType): string[] {
        if (netzbetreiberType && netzbetreiberType === 'WESTNETZ') {
            return [
                ...NetzzuordnungenTableComponent.WESTNETZ_COLUMNS_PRE,
                ...NetzzuordnungenTableComponent.DEFAULT_COLUMNS,
                ...NetzzuordnungenTableComponent.WESTNETZ_COLUMNS_POST,
            ];
        } else {
            return NetzzuordnungenTableComponent.DEFAULT_COLUMNS;
        }
    }
}
